export default {
    AUCTION: 'Auction',
    CART: 'Cart',
    BIN: 'Bin'
};
